import './PastShowsTab.css';

import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import { useEffect, useState } from 'react';
import SectionLoader from '../../../../_shoru_shared_library/loaders/SectionLoader';


export default function PastShowsTab({projectData, organisationData:organisation, narrow}) {

  const [seasons, setSeasons] = useState(null);

  const getSlug = (str) => str.trim().toLowerCase().replace(/\s+/g, '-');

  useEffect(() => {
    if(seasons) return;
    let newSeasons = organisation.seasons.map((season) => {
      let types = []
      projectData.filter(p => p.season === season.uid).forEach((p) => {
        if(!types.some((x) => x.slug === getSlug(p.project_type))) {
          types.push({name: p.project_type.trim(), slug: getSlug(p.project_type)})
        }
      })
      return {
        name: season.name,
        uid: season.uid,
        types: types.map((type) => {
          return {
            project_type: type.name,
            projects: projectData.filter((p) => p.season === season.uid && getSlug(p.project_type) === type.slug).sort((a,b) => a.week - b.week)
          }
        }).sort((a,b) => a.project_type.localeCompare(b.project_type))
      }
    }).reverse();
    setSeasons(newSeasons)
  }, [])


  if(seasons === null) return <SectionLoader />

  
  return (
    <SubTabParent>
      <SubTabSection no_background>
        {
          seasons.map((s, i) => {
            return (
              <div className='past-shows-season'>
                <h3>{s.name}</h3>
                {
                  s.types.map((t, i) => 
                    <div className='past-shows-table-container'>
                      <div className='past-shows-table-title'>{t.project_type}s</div>
                      <div key={i} className='past-shows-table'>
                        {
                          t.projects.map((p) => 
                            <div className='past-shows-item'>
                              <div style={{color: '#777', flexShrink: 0}}>
                                Week {p.week}
                              </div>
                              <div style={{marginLeft: '20px'}}>
                                {p.name} <span className='past-shows-playwright'>{p.playwright && !narrow ? ` by ${p.playwright}` : ''}</span>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  )
                }
              </div>
            )
          })
        }
      </SubTabSection>
    </SubTabParent>
  )

}